import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useDeleteAppointmentType = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'delete',
        `facility/${user.facility}/appointment-types/${data._id}`,
        true,
      );
    },
    {
      onSuccess: async () => {
        toast('Appointment Type was successfully deleted', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries([cacheKeys.getAppointmentTypes()]);
      },
      onError: async (err) => {
        toast('Unable to delete Appointment Type', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to delete Appointment Type: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
